import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

export function slidingBetslipButtonFactory(PALETTE) {
    const {FONT} = PALETTE;

    return {
        BetslipButtonView: {
            button: {
                style: {
                    base: {
                        ...resolveBackground(PALETTE.SLIDING_BETSLIP_BUTTON_BASE_BG),
                        flexGrow: '0',
                        flexShrink: '0',
                        flexBasis: 'auto',
                        minHeight: 'initial',
                        borderWidth: '0px',
                        borderRadius: '48px',
                        boxShadow: PALETTE.SLIDING_BETSLIP_BUTTON_SHADOW,
                        fontSize: '20px',
                        fontWeight: FONT.WEIGHT_BOLD,
                        width: 48,
                        height: 48,
                        ...PALETTE.SLIDING_BETSLIP_BUTTON_BASE_TEXT,
                    },
                },
            },
            style: {
                highlighted: {
                    ...resolveBackground(PALETTE.SLIDING_BETSLIP_BUTTON_HIGHLIGHTED_BG),
                    ...PALETTE.SLIDING_BETSLIP_BUTTON_HIGHLIGHTED_TEXT,
                },
            },
            imageButton: {
                button: {
                    style: {
                        base: {
                            ...resolveBackground(PALETTE.SLIDING_BETSLIP_BUTTON_SUCCESS_BG),
                            flexGrow: '0',
                            flexShrink: '0',
                            flexBasis: 'auto',
                            minHeight: 'initial',
                            borderRadius: 48,
                            boxShadow: PALETTE.SLIDING_BETSLIP_BUTTON_SHADOW,
                            height: 48,
                            width: 48,
                        },
                    },
                },
                buttonIcon: icon(PALETTE.SLIDING_BETSLIP_BUTTON_SUCCESS_ICON_COLOR),
            },
            overaskImageButton: {
                button: {
                    style: {
                        base: {
                            ...resolveBackground(PALETTE.SLIDING_BETSLIP_BUTTON_OVERASK_BG),
                            flexGrow: '0',
                            flexShrink: '0',
                            flexBasis: 'auto',
                            borderRadius: 48,
                            boxShadow: PALETTE.SLIDING_BETSLIP_BUTTON_SHADOW,
                            height: 48,
                            width: 48,
                        },
                    },
                },
                buttonIcon: icon(PALETTE.SLIDING_BETSLIP_BUTTON_OVERASK_ICON_COLOR),
            },
            freebetsIconContainer: {
                style: {
                    ...resolveBackground(PALETTE.SLIDING_BETSLIP_BUTTON_FREEBETS_CONTAINER_BG),
                    borderRadius: 16,
                },
            },
            freebetsIcon: {
                style: {
                    fill: PALETTE.SLIDING_BETSLIP_BUTTON_FREEBETS_ICON_COLOR,
                },
            },
        },
    };
}
